"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Genre = void 0;
class Genre {
    constructor(genre) {
        this.active = genre.active;
        this.altered = genre.altered;
        this.created = genre.created;
        this.description = genre.description;
        this.name = genre.name;
        this.sql_id = genre.sql_id;
        this.querySnap = genre.querySnap;
        this.documentId = genre.documentId;
        this.ref = genre.ref;
    }
    async fromCollection(collection) {
        const collectionSnapshot = await collection.get();
        return this.fromDocumentSnapshotArray(collectionSnapshot.docs);
    }
    fromDocumentSnapshot(documentSnapshot) {
        return new Genre({
            ...documentSnapshot.data(),
            querySnap: documentSnapshot,
            documentId: documentSnapshot.id,
            ref: documentSnapshot.ref
        });
    }
    fromDocumentSnapshotArray(documentSnapshot) {
        return documentSnapshot.map(document => {
            return new Genre({
                ...document.data(),
                querySnap: document,
                documentId: document.id,
                ref: document.ref
            });
        });
    }
}
exports.Genre = Genre;
//# sourceMappingURL=Genre.js.map